import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import fetch from 'unfetch';
import DropdownList from './DropdownList';
import LegalLinks from './LegalLinks';
import Sponsor from './Sponsor';
import ClubFooterStrip from './ClubFooterStrip';
import { transformNavVariables } from '../scripts/dataModel';
import { modelStyleProps } from '../scripts/dataModelFooter';
import FooterStyle from './FooterStyle';
var initStateFooter = require('../config/init-state-footer.json');
var Footer = /*#__PURE__*/function (_React$Component) {
  _inherits(Footer, _React$Component);
  var _super = _createSuper(Footer);
  function Footer(props) {
    var _this;
    _classCallCheck(this, Footer);
    _this = _super.call(this, props);
    _this.state = {
      footerData: props.footerData
    };
    _this.parseData = _this.parseData.bind(_assertThisInitialized(_this));
    _this.addAbsoluteUrl = _this.addAbsoluteUrl.bind(_assertThisInitialized(_this));
    _this.dataAttributes = _this.dataAttributes.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Footer, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props, locale, clubId, useFeen, localeSlug, feenFooter, footerData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, locale = _this$props.locale, clubId = _this$props.clubId, useFeen = _this$props.useFeen;
              localeSlug = locale === 'es' ? '-es' : '';
              feenFooter = "https://feen.cms.mlbinfra.com/cms/api/public/menuitems/_navs/footer/".concat(clubId, "/global-footer").concat(localeSlug);
              if (!useFeen) {
                _context.next = 14;
                break;
              }
              _context.prev = 4;
              _context.next = 7;
              return fetch(feenFooter).then(function (r) {
                return r.json();
              }).then(function (data) {
                return data;
              });
            case 7:
              footerData = _context.sent;
              if ((footerData === null || footerData === void 0 ? void 0 : footerData.menuItems.length) > 0) {
                this.setState({
                  footerData: footerData
                });
              }
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              console.error('error fetching client side footer data', _context.t0);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 11]]);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "addAbsoluteUrl",
    value: function addAbsoluteUrl(navItem, baseDomain) {
      var properties = navItem.properties;
      var link = properties.link;
      return !link || link.includes('http://') || link.includes('https://') ? navItem : _objectSpread(_objectSpread({}, navItem), {}, {
        properties: _objectSpread(_objectSpread({}, properties), {}, {
          link: baseDomain + link
        })
      });
    }
  }, {
    key: "parseData",
    value: function parseData(navItems, baseDomain) {
      var _this2 = this;
      if (!navItems || !navItems.length) {
        return {};
      }
      return navItems.reduce(function (acc, itemData) {
        var hasMenuItems = itemData && itemData.menuItems && itemData.menuItems.length;
        var isTeamLinks = itemData.text === 'top';
        var item = baseDomain ? _objectSpread(_objectSpread({}, _this2.addAbsoluteUrl(itemData, baseDomain)), {}, {
          menuItems: hasMenuItems && itemData.menuItems.map(function (subnavItem) {
            return _this2.addAbsoluteUrl(subnavItem, baseDomain);
          })
        }) : itemData;
        if (!hasMenuItems && !isTeamLinks) {
          acc.legalLinks.push(item);
        }
        if (hasMenuItems && isTeamLinks) {
          acc.teamLinks.push(item);
        }
        if (hasMenuItems && !isTeamLinks) {
          acc.dropdowns.push(item);
        }
        return acc;
      }, {
        legalLinks: [],
        teamLinks: [],
        dropdowns: []
      });
    }
  }, {
    key: "dataAttributes",
    value: function dataAttributes(isClub) {
      if (isClub) {
        return {
          'data-is-club': 'true'
        };
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        clubId = _this$props2.clubId,
        id = _this$props2.id,
        locale = _this$props2.locale,
        teamNameSlug = _this$props2.teamNameSlug,
        contentfulProps = _this$props2.contentfulProps,
        linkBaseUrl = _this$props2.linkBaseUrl;
      var footerData = this.state.footerData;
      var hasContentful = Object.keys(contentfulProps).length > 0;
      var isClub = !['mlb', 'milb'].includes(clubId);
      var _modelStyleProps = modelStyleProps(contentfulProps),
        urlLogo = _modelStyleProps.urlLogo,
        theme = _modelStyleProps.theme;
      var _ref = footerData || {},
        variables = _ref.variables;
      var _transformNavVariable = transformNavVariables(variables),
        hidesocial = _transformNavVariable.hidesocial,
        secondarylogosrc = _transformNavVariable.secondarylogosrc,
        _transformNavVariable2 = _transformNavVariable.secondarylogoalt,
        secondarylogoalt = _transformNavVariable2 === void 0 ? '' : _transformNavVariable2,
        secondarylogolink = _transformNavVariable.secondarylogolink;
      var hideSocial = Boolean(hidesocial || isClub);
      var secondaryLogo = secondarylogosrc ? {
        alt: secondarylogoalt,
        link: secondarylogolink,
        src: secondarylogosrc
      } : null;
      var _this$parseData = this.parseData(footerData.menuItems, linkBaseUrl),
        legalLinks = _this$parseData.legalLinks,
        dropdowns = _this$parseData.dropdowns,
        teamLinks = _this$parseData.teamLinks;
      return /*#__PURE__*/React.createElement(FooterStyle, {
        className: className,
        id: id,
        theme: theme
      }, /*#__PURE__*/React.createElement("div", _extends({
        className: "site-footer"
      }, this.dataAttributes(isClub)), !isClub && /*#__PURE__*/React.createElement(DropdownList, {
        dropdowns: dropdowns
      }), /*#__PURE__*/React.createElement("div", {
        className: "site-footer__frame"
      }, isClub && hasContentful && /*#__PURE__*/React.createElement(ClubFooterStrip, {
        teamLinks: teamLinks,
        urlLogo: urlLogo,
        locale: locale,
        teamNameSlug: teamNameSlug
      }), /*#__PURE__*/React.createElement("div", {
        className: "site-footer__container"
      }, /*#__PURE__*/React.createElement(Sponsor, {
        hideSocial: hideSocial,
        locale: locale,
        secondaryLogo: secondaryLogo
      }), /*#__PURE__*/React.createElement(LegalLinks, {
        legalLinks: legalLinks,
        locale: locale,
        teamNameSlug: teamNameSlug
      })))));
    }
  }]);
  return Footer;
}(React.Component);
export default Footer;
Footer.propTypes = {
  className: PropTypes.string,
  clubId: PropTypes.string,
  contentfulProps: PropTypes.shape({
    properties: PropTypes.shape({}),
    palette: PropTypes.shape({})
  }),
  footerData: PropTypes.shape({
    menuItems: PropTypes.instanceOf(Array),
    variables: PropTypes.instanceOf(Array)
  }).isRequired,
  id: PropTypes.string,
  locale: PropTypes.string,
  teamNameSlug: PropTypes.string,
  deviceProperties: PropTypes.shape({}).isRequired,
  linkBaseUrl: PropTypes.string,
  useFeen: PropTypes.bool
};
Footer.defaultProps = {
  clubId: 'mlb',
  contentfulProps: {},
  deviceProperties: {},
  footerData: initStateFooter.footerData,
  id: 'react-footer',
  isLegacy: false,
  isMicrositeIndex: false,
  locale: 'en',
  sharedNav: {},
  teamNameSlug: '',
  linkBaseUrl: '',
  useFeen: false
};